<script>
import ServicePrices from "@/modules/Tour/Admin/Item/Services/Item/ServicePrices.vue";

export default {
  components: {ServicePrices},
  props: {
    module: {
      type: Object,
    },
  },
  data() {
    return {
      servicePrices: this.module.servicePrices,
      activeName: 'serviceParameters',
    };
  },
};
</script>
<template>
  <FBody
    :module="module"
    @submit="$emit('submit')"
  >
    <el-tabs v-model="activeName">
      <el-tab-pane label="Услуга" name="serviceParameters">
    <RowSpan>
      <ColGroup label="Направление" :span="5">
        <FItem
          :module="module.getItem('country')"
        />
      </ColGroup>
      <ColGroup label="Направление" :span="5">
        <FItem
          :module="module.getItem('city')"
        />
      </ColGroup>
      <ColGroup label="Квота" :span="2">
        <FItem
          :module="module.getItem('quota')"
        />
      </ColGroup>
    </RowSpan>
    <RowSpan>
      <ColGroup label="Описание">
        <FItem
          :module="module.getItem('additional')"
        />
      </ColGroup>
    </RowSpan>
    <RowSpan>
      <ColSpan span="6">
        <FItem
          :module="module.startDay"
        />
      </ColSpan>
      <ColSpan span="6">
        <FItem
          :module="module.startTime"
        />
      </ColSpan>
    </RowSpan>
    <RowSpan>
      <ColSpan span="6">
        <FItem
          :module="module.durationDay"
        />
      </ColSpan>
      <ColSpan span="6">
        <FItem
          :module="module.durationHour"
        />
      </ColSpan>
    </RowSpan>
      </el-tab-pane>
      <el-tab-pane label="Тарифы" name="tariffs">
        <ServicePrices :source-service-prices="servicePrices" :serviceClassId="module.service.value.value">
        </ServicePrices>
      </el-tab-pane>
    </el-tabs>
  </FBody>
</template>
<style lang="scss">

</style>
